// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 635) return "js/635.3d00797c5651c9866005.bundle.js";
	if (chunkId === 617) return "js/SchoolClasses.493d3a92580ef732990c.bundle.js";
	if (chunkId === 997) return "js/997.73dbf9d1ba68dc2ce07c.bundle.js";
	if (chunkId === 727) return "js/npm.canvg.b561d38ba061b4755779.bundle.js";
	if (chunkId === 279) return "js/279.e94da11bc9601297378e.bundle.js";
	if (chunkId === 603) return "js/npm.core-js.d5ea7c047409c4f70b04.bundle.js";
	// return url for filenames based on template
	return undefined;
};